// Web Crypto API: available as `globalThis.crypto` in browsers and Node 18+.
// Using the global avoids bundler-specific `node:crypto` shims and works in
// both webpack (web) and vite (mobile) targets without polyfills.
const getSubtle = (): SubtleCrypto => {
  const cryptoObj = globalThis.crypto
  if (!cryptoObj?.subtle) {
    throw new Error('Web Crypto API not available: globalThis.crypto.subtle is undefined')
  }
  return cryptoObj.subtle
}

export const encryptAesGcm = async (
  plaintext: Uint8Array,
  keyBytes: Uint8Array,
  iv: Uint8Array,
): Promise<Uint8Array> => {
  const subtle = getSubtle()

  const key = await subtle.importKey('raw', keyBytes as BufferSource, { name: 'AES-GCM' }, false, [
    'encrypt',
    'decrypt',
  ])

  const ciphertext = await subtle.encrypt(
    { name: 'AES-GCM', iv: iv as BufferSource },
    key,
    plaintext as BufferSource,
  )

  return new Uint8Array(ciphertext)
}

export const decryptAesGcm = async (
  ciphertext: Uint8Array,
  keyBytes: Uint8Array,
  iv: Uint8Array,
): Promise<Uint8Array> => {
  const subtle = getSubtle()

  const key = await subtle.importKey('raw', keyBytes as BufferSource, { name: 'AES-GCM' }, false, [
    'encrypt',
    'decrypt',
  ])

  const plaintext = await subtle.decrypt(
    { name: 'AES-GCM', iv: iv as BufferSource },
    key,
    ciphertext as BufferSource,
  )

  return new Uint8Array(plaintext)
}
